/*eslint-disable*/
import React from "react"
// nodejs library to set properties for components
import PropTypes from "prop-types"
// nodejs library that concatenates classes
import classNames from "classnames"
import { withStyles } from "@material-ui/core"
import footerStyle from "../../assets/jss/material-kit-react/components/footerStyle.jsx"
import GridItem from "../Grid/GridItem"
import GridContainer from "../Grid/GridContainer"
import TermsScrollDialog from "../ScrollDialog/TermsScrollDialog"
import PrivacyScrollDialog from "../ScrollDialog/PrivacyScrollDialog"
import FaqScrollDialog from "../ScrollDialog/FaqScrollDialog"
import ScrollableAnchor from "react-scrollable-anchor"
import Hidden from "@material-ui/core/Hidden"

// @material-ui/icons

class Footer extends React.Component {
    state = {
        termsOpened: false,
        privacyOpened: false,
        faqOpened: false,
    }

    handlePopoverOpen = (e, type) => {
        e.preventDefault()
        this.setState({
            [type]: true,
        })
    }

    handlePopoverClosed = (e, type) => {
        e.preventDefault()
        this.setState({
            [type]: false,
        })
    }

    render() {
        const { classes, whiteFont } = this.props
        const footerClasses = classNames({
            [classes.footer]: true,
            [classes.footerWhiteFont]: whiteFont,
        })
        const aClasses = classNames({
            [classes.a]: true,
            [classes.footerWhiteFont]: whiteFont,
        })
        return (
            <footer
                className={footerClasses}
                style={{
                    backgroundColor: "#2D3C48",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                }}>
                <ScrollableAnchor id="contact">
                    <div>
                        <TermsScrollDialog
                            open={this.state.termsOpened}
                            handleClose={e => this.handlePopoverClosed(e, "termsOpened")}
                        />
                        <PrivacyScrollDialog
                            open={this.state.privacyOpened}
                            handleClose={e => this.handlePopoverClosed(e, "privacyOpened")}
                        />
                        <FaqScrollDialog
                            open={this.state.faqOpened}
                            handleClose={e => this.handlePopoverClosed(e, "faqOpened")}
                        />

                        <div className={classes.container}>
                            <div className={classes.center}>
                                <GridContainer>
                                    <Hidden only={["xs", "sm", "md"]}>
                                        {/* Only Large */}
                                        <GridItem
                                            xs={0}
                                            sm={0}
                                            md={12}
                                            lg={12}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                            }}>
                                            <span style={{ color: "#fff", fontWeight: "400", fontSize: "2rem" }}>
                                                <strong>
                                                    <a
                                                        className={classes.linkFooter}
                                                        href="tel:9292956829"
                                                        style={{ color: "#fff" }}>
                                                        Call (929) 295-6829
                                                    </a>
                                                </strong>
                                                <span> or </span>
                                                <strong>
                                                    <a
                                                        style={{ color: "#fff" }}
                                                        href="mailto:sales@figurepos.com"
                                                        className={classes.linkFooter}>
                                                        Email
                                                    </a>
                                                </strong>{" "}
                                                us at anytime!
                                            </span>
                                        </GridItem>
                                    </Hidden>

                                    <Hidden only={["lg", "xl"]}>
                                        {/* Only Small */}
                                        <GridItem
                                            xs={12}
                                            sm={12}
                                            md={0}
                                            lg={0}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                            }}>
                                            <span style={{ color: "#fff", fontWeight: "400", fontSize: "2rem" }}>
                                                <strong>
                                                    <a
                                                        className={classes.linkFooter}
                                                        href="tel:9292956829"
                                                        style={{ color: "#fff" }}>
                                                        Call (929) 295-6829
                                                    </a>
                                                </strong>
                                            </span>
                                        </GridItem>

                                        <GridItem
                                            xs={12}
                                            sm={12}
                                            md={0}
                                            lg={0}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                            }}>
                                            <span
                                                style={{
                                                    color: "#fff",
                                                    fontWeight: "400",
                                                    fontSize: "2rem",
                                                    padding: "1rem 0",
                                                }}>
                                                <span> or </span>
                                            </span>
                                        </GridItem>

                                        <GridItem
                                            xs={12}
                                            sm={12}
                                            md={0}
                                            lg={0}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                            }}>
                                            <span style={{ color: "#fff", fontWeight: "400", fontSize: "2rem" }}>
                                                <strong>
                                                    <a
                                                        style={{ color: "#fff" }}
                                                        href="mailto:sales@figurepos.com"
                                                        className={classes.linkFooter}>
                                                        Email
                                                    </a>
                                                </strong>{" "}
                                                us at anytime!
                                            </span>
                                        </GridItem>
                                    </Hidden>
                                </GridContainer>
                            </div>
                        </div>
                    </div>
                </ScrollableAnchor>
            </footer>
        )
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    whiteFont: PropTypes.bool,
}

export default withStyles(footerStyle)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx